import { render } from "./Booth.vue?vue&type=template&id=1a2dc336"
import script from "./Booth.vue?vue&type=script&lang=js"
export * from "./Booth.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\Mbf5_HCC\\XaQuangHa\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__